import reduceMedias from 'utils/reduceMedias'
import { limit } from 'consts'
import { mediaSearchQuery } from 'utils/queries'

export default async ({ path, graphql, state }) => {
  const { mediaBySearch: { medias } } = await graphql.query(
    mediaSearchQuery({
      sortType: 'LATEST',
      criteria: '',
      skip: 0,
      limit,
      count: false
    })
  )

  return path.loaded({
    files: reduceMedias(medias)
  })
}



// WEBPACK FOOTER //
// ./src/modules/Media/actions/loadLatest.js